// Override `lattitude` & `longitude` in response data within user event values to place marker in exact place
export function toPreparedGoogleMapAddress(data, event) {
  return {
    ...data.results[0],
    geometry: {
      location: {
        lat: event?.detail.latLng.lat ?? data.results[0].geometry.location.lat,
        lng: event?.detail.latLng.lng ?? data.results[0].geometry.location.lng,
      },
    },
  }
}
